import { getDocument, GlobalWorkerOptions } from 'pdfjs-dist';
import workerSrc from 'pdfjs-dist/build/pdf.worker.min.mjs?url';

// Bundle the worker from the installed pdfjs-dist package so the API and worker
// versions always match. (A CDN URL pinned to a different version makes pdf.js
// throw "API version does not match Worker version" at runtime.)
GlobalWorkerOptions.workerSrc = workerSrc;

export async function renderPdfPagesToImages(
  file: File | ArrayBuffer,
  opts: { scale?: number; maxPages?: number } = {},
): Promise<string[]> {
  const scale = opts.scale ?? 2;
  const maxPages = opts.maxPages ?? 20;
  const data = file instanceof ArrayBuffer ? new Uint8Array(file) : new Uint8Array(await file.arrayBuffer());
  const pdf = await getDocument({ data }).promise;
  const count = Math.min(pdf.numPages, maxPages);
  const out: string[] = [];
  for (let i = 1; i <= count; i++) {
    const page = await pdf.getPage(i);
    const viewport = page.getViewport({ scale });
    const canvas = document.createElement('canvas');
    canvas.width = Math.ceil(viewport.width);
    canvas.height = Math.ceil(viewport.height);
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('2D canvas context unavailable');
    await page.render({ canvasContext: ctx as any, viewport } as any).promise;
    out.push(canvas.toDataURL('image/jpeg', 0.85));
    console.log(`[TeCS-OCR] rendered page ${i}/${count}`);
  }
  return out;
}
